(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-m04-formula"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vb-matero-video')){customElements.define('vb-matero-video',class extends HTMLElement{connectedCallback(){requestAnimationFrame(()=>{if(this.ready)return;this.ready=true;const video=this.querySelector('video'),button=this.querySelector('[data-play]');if(!video||!button)return;button.addEventListener('click',()=>{video.controls=true;video.play().then(()=>button.hidden=true).catch(()=>{button.hidden=true;});});video.addEventListener('pause',()=>button.hidden=false);video.addEventListener('ended',()=>button.hidden=false);});}disconnectedCallback(){this.querySelector('video')?.pause();}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-m05-comparison"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vb-matero-scroll')){customElements.define('vb-matero-scroll',class extends HTMLElement{connectedCallback(){requestAnimationFrame(()=>{if(!this.isConnected)return;this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal;const track=this.querySelector('[data-track]');if(!track)return;const prev=[...this.querySelectorAll('[data-prev]')],next=[...this.querySelectorAll('[data-next]')];const update=()=>{const max=track.scrollWidth-track.clientWidth;prev.forEach(b=>b.disabled=track.scrollLeft<2);next.forEach(b=>b.disabled=max<2||track.scrollLeft>max-2);this.querySelectorAll('[data-progress]').forEach(p=>p.style.transform='scaleX('+(max<2?1:track.scrollLeft/max)+')');};const move=d=>track.scrollBy({left:d*track.clientWidth*.8,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});prev.forEach(b=>b.addEventListener('click',()=>move(-1),{signal}));next.forEach(b=>b.addEventListener('click',()=>move(1),{signal}));track.addEventListener('scroll',update,{passive:true,signal});this.ro?.disconnect();this.ro=new ResizeObserver(update);this.ro.observe(track);document.addEventListener('shopify:block:select',e=>{if(this.contains(e.target))e.target.scrollIntoView({behavior:'instant',block:'nearest',inline:'nearest'});},{signal});update();});}disconnectedCallback(){this.abort?.abort();this.ro?.disconnect();}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-m06-accordion"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vb-matero-details')){customElements.define('vb-matero-details',class extends HTMLElement{connectedCallback(){this.abort?.abort();this.abort=new AbortController();document.addEventListener('shopify:block:select',e=>{if(!this.contains(e.target))return;const panel=e.target.closest('details');if(panel)panel.open=true;},{signal:this.abort.signal});}disconnectedCallback(){this.abort?.abort();}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-m07-experiences"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vb-matero-scroll')){customElements.define('vb-matero-scroll',class extends HTMLElement{connectedCallback(){requestAnimationFrame(()=>{if(!this.isConnected)return;this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal;const track=this.querySelector('[data-track]');if(!track)return;const prev=[...this.querySelectorAll('[data-prev]')],next=[...this.querySelectorAll('[data-next]')];const update=()=>{const max=track.scrollWidth-track.clientWidth;prev.forEach(b=>b.disabled=track.scrollLeft<2);next.forEach(b=>b.disabled=max<2||track.scrollLeft>max-2);this.querySelectorAll('[data-progress]').forEach(p=>p.style.transform='scaleX('+(max<2?1:track.scrollLeft/max)+')');};const move=d=>track.scrollBy({left:d*track.clientWidth*.8,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});prev.forEach(b=>b.addEventListener('click',()=>move(-1),{signal}));next.forEach(b=>b.addEventListener('click',()=>move(1),{signal}));track.addEventListener('scroll',update,{passive:true,signal});this.ro?.disconnect();this.ro=new ResizeObserver(update);this.ro.observe(track);document.addEventListener('shopify:block:select',e=>{if(this.contains(e.target))e.target.scrollIntoView({behavior:'instant',block:'nearest',inline:'nearest'});},{signal});update();});}disconnectedCallback(){this.abort?.abort();this.ro?.disconnect();}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-m12-faq"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vb-matero-details')){customElements.define('vb-matero-details',class extends HTMLElement{connectedCallback(){this.abort?.abort();this.abort=new AbortController();document.addEventListener('shopify:block:select',e=>{if(!this.contains(e.target))return;const panel=e.target.closest('details');if(panel)panel.open=true;},{signal:this.abort.signal});}disconnectedCallback(){this.abort?.abort();}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-v2-countdown"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vb-offer-countdown')) {
  customElements.define('vb-offer-countdown', class extends HTMLElement {
    connectedCallback() {
      cancelAnimationFrame(this.frame);
      clearInterval(this.timer);
      this.frame = requestAnimationFrame(() => {
        if (!this.isConnected) return;
        const clock = this.querySelector('.vbc-clock');
        if (!clock) return;
        const fields = ['hours', 'minutes', 'seconds'].map(
          key => this.querySelector('[data-' + key + ']')
        );
        const tick = () => {
          const now = new Date();
          const midnight = new Date(now);
          midnight.setHours(24, 0, 0, 0);
          const seconds = Math.max(0, Math.ceil((midnight - now) / 1000));
          const values = [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60];
          fields.forEach((field, index) => {
            if (field) field.textContent = String(values[index]).padStart(2, '0');
          });
          clock.hidden = false;
        };
        tick();
        this.timer = setInterval(tick, 1000);
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      clearInterval(this.timer);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-v2-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vb-product-offer')) {
 customElements.define('vb-product-offer', class extends HTMLElement {
  connectedCallback() {
   requestAnimationFrame(() => {
    if (!this.isConnected) return;
    if (this.initialized) {document.addEventListener('shopify:block:select',this.onBlock);window.addEventListener('scroll',this.onStickyScroll,{passive:true});window.addEventListener('resize',this.onStickyScroll);this.onStickyScroll();this.mobileMedia?.addEventListener('change',this.syncNotes);this.syncNotes?.();const gallery=this.querySelector('.vb2-gallery');if(gallery)this.galleryResize?.observe(gallery);return;}
    this.initialized=true;
    const slides=[...this.querySelectorAll('[data-slide]')];
    const thumbs=[...this.querySelectorAll('[data-thumb]')];
    const show=i=>{slides.forEach((s,j)=>{s.hidden=i!==j;if(s.hidden)s.querySelectorAll('video').forEach(v=>v.pause());});thumbs.forEach((b,j)=>b.setAttribute('aria-pressed',String(i===j)));};
    thumbs.forEach((b,i)=>b.addEventListener('click',()=>show(i)));
    const dialog=this.querySelector('dialog');
    this.querySelectorAll('[data-zoom]').forEach(b=>b.addEventListener('click',()=>{if(b.disabled||!b.dataset.zoom)return;const img=dialog.querySelector('img');img.src=b.dataset.zoom;img.alt=b.querySelector('img')?.alt||'';dialog.showModal();}));
    this.querySelector('[data-close]')?.addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
    this.onBlock=e=>{if(!this.contains(e.target))return;const s=e.target.closest('[data-slide]');if(s)show(slides.indexOf(s));};
    document.addEventListener('shopify:block:select',this.onBlock);
    const form=this.querySelector('.vb2-product-form');
    const syncBundleTerms=()=>{const terms=this.querySelector('[data-bundle-terms]');if(terms)terms.hidden=!this.querySelector('.rapi-subscription-toggleCheckbox input')?.checked;};this.onBundleChange=()=>requestAnimationFrame(syncBundleTerms);form?.addEventListener('change',this.onBundleChange);form?.addEventListener('click',this.onBundleChange);this.bundleObserver=new MutationObserver(syncBundleTerms);if(form)this.bundleObserver.observe(form,{childList:true,subtree:true});syncBundleTerms();
    const notes=this.querySelector('.vb2-gallery-notes'),notesHome=notes?.parentElement;this.mobileMedia=window.matchMedia('(max-width:989px)');this.syncNotes=()=>{if(!notes)return;const after=this.querySelector('.vb2-trust')||this.querySelector('.vb2-delivery-labels')||form;if(this.mobileMedia.matches&&after){after.after(notes);}else{notesHome?.append(notes);}};this.mobileMedia.addEventListener('change',this.syncNotes);this.syncNotes();
    this.querySelectorAll('[data-inline-play]').forEach(b=>b.addEventListener('click',()=>{const v=b.parentElement.querySelector('video');v.controls=true;v.play().then(()=>b.hidden=true).catch(()=>b.hidden=true);}));
    const mediaTrack=this.querySelector('.vb2-media-track');this.querySelector('[data-media-prev]')?.addEventListener('click',()=>mediaTrack.scrollBy({left:-mediaTrack.clientWidth*.7,behavior:'smooth'}));this.querySelector('[data-media-next]')?.addEventListener('click',()=>mediaTrack.scrollBy({left:mediaTrack.clientWidth*.7,behavior:'smooth'}));
    const sticky=this.querySelector('.vb2-sticky-offer'),buy=form?.querySelector('[name="add"]');this.querySelector('[data-sticky-buy]')?.addEventListener('click',()=>{const add=form?.querySelector('[name="add"]');if(add&&!add.disabled){add.click();}else{form?.scrollIntoView({behavior:'smooth',block:'center'});}});this.onStickyScroll=()=>{if(this.stickyFrame)return;this.stickyFrame=requestAnimationFrame(()=>{this.stickyFrame=0;if(sticky&&buy)sticky.hidden=buy.getBoundingClientRect().bottom>0;});};window.addEventListener('scroll',this.onStickyScroll,{passive:true});window.addEventListener('resize',this.onStickyScroll);this.onStickyScroll();
    const gallery=this.querySelector('.vb2-gallery');this.galleryResize=new ResizeObserver(()=>{if(gallery)gallery.style.top=Math.min(24,innerHeight-gallery.offsetHeight-24)+'px';});if(gallery)this.galleryResize.observe(gallery);

   });
  }
  disconnectedCallback(){this.bundleObserver?.disconnect();const form=this.querySelector('.vb2-product-form');form?.removeEventListener('change',this.onBundleChange);form?.removeEventListener('click',this.onBundleChange);this.mobileMedia?.removeEventListener('change',this.syncNotes);window.removeEventListener('scroll',this.onStickyScroll);window.removeEventListener('resize',this.onStickyScroll);cancelAnimationFrame(this.stickyFrame);this.galleryResize?.disconnect();document.removeEventListener('shopify:block:select',this.onBlock);this.querySelector('dialog[open]')?.close();this.querySelectorAll('video').forEach(v=>v.pause());}
 });
}

  } catch(e) { console.error(e); }
})();
})();
